<template>
  <div
    v-tooltip="{ content: disabled ? tooltip : '' }"
    class="group flex items-center gap-3"
  >
    <label
      v-if="leftLabel"
      :for="uuid"
      class="block cursor-pointer font-inter text-xs font-medium leading-5 text-gray-200 transition duration-300 group-focus-within:!text-gray-100 group-hover:text-gray-100"
      :class="{
        '!text-gray-300': disabled,
        'flex items-center': tip,
      }"
    >
      {{ leftLabel }}

      <TTip v-if="tip" :tip="tip" />
    </label>
    <Switch
      :id="uuid"
      v-model="enabled"
      tabindex="0"
      :class="{
        '!bg-accent-1': enabled,
      }"
      class="duration-600 relative inline-flex h-[20px] w-[36px] flex-[0_0_36px] cursor-pointer items-center rounded-xl bg-gray-600 transition focus:bg-gray-600 focus:outline focus:outline-2 focus:outline-offset-[-2px] focus:outline-accent-1 disabled:!cursor-not-allowed disabled:!bg-gray-600 group-hover:bg-gray-400"
      :disabled="disabled"
    >
      <span class="sr-only">Enable notifications</span>
      <span
        :class="{
          'translate-x-5 !bg-white dark:!bg-gray-10': enabled,
          'translate-x-1': !enabled,
          '!bg-gray-200': disabled,
        }"
        class="group-focus-whithin:bg-gray-100 dark:group-focus-whithin:bg-gray-100 inline-block h-[12px] w-[12px] translate-y-0 rotate-0 skew-x-0 skew-y-0 scale-100 transform rounded-full bg-gray-100 transition duration-300 group-hover:bg-gray-50"
      />
    </Switch>
    <label
      :for="uuid"
      class="block cursor-pointer font-inter text-xs font-medium leading-5 text-gray-200 transition duration-300 group-focus-within:!text-gray-100 group-hover:text-gray-100"
      :class="{
        '!text-gray-300': disabled,
        'flex items-center': tip || changed,
      }"
    >
      {{ label }}

      <TTip v-if="tip" :tip="tip" />
      <div
        v-if="changed"
        class="text-accent-1 cursor-pointer opacity-75 hover:opacity-100"
        data-testid="reset-label"
        v-tooltip="{
          content: resetTooltip,
        }"
        @click.stop.prevent="$emit('reset')"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5156 8.03906C13.8203 7.75781 13.8203 7.26562 13.5156 6.98438C13.2344 6.67969 12.7422 6.67969 12.4609 6.98438L10 9.44531L7.51562 6.98438C7.23438 6.67969 6.74219 6.67969 6.46094 6.98438C6.15625 7.26562 6.15625 7.75781 6.46094 8.03906L8.92188 10.5L6.46094 12.9844C6.15625 13.2656 6.15625 13.7578 6.46094 14.0391C6.74219 14.3438 7.23438 14.3438 7.51562 14.0391L10 11.5781L12.4609 14.0391C12.7422 14.3438 13.2344 14.3438 13.5156 14.0391C13.8203 13.7578 13.8203 13.2656 13.5156 12.9844L11.0547 10.5L13.5156 8.03906Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </label>
  </div>
</template>
<script lang="ts" setup>
import TTip from "../TTip/TTip.vue";
import { Switch } from "@headlessui/vue";
import { v4 as uuidv4 } from "uuid";
import { computed } from "vue";

const uuid = uuidv4();

const props = withDefaults(
  defineProps<{
  modelValue?: boolean;
  disabled?: boolean;
  label?: string;
  leftLabel?: string;
  tooltip?: string;
  tip?: string;
  changed?: boolean;
  resetTooltip?: string;
  }>(),
  {
    modelValue: false,
  },
);

const emit = defineEmits(["update:modelValue", "reset"]);

const enabled = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    if (props.disabled !== true) {
      emit("update:modelValue", val);
    }
  },
});
</script>
<style lang="scss"></style>
